import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectHelpTopicsListItems } from "../../../../../redux/help-topics/selector";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { helpTopics } from "../../../../../redux/help-topics/action";


const ManagementHelpTopics = () => {
	const dispatch = useAppDispatch()

  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)
    const helpTopicsItems = useSelector(selectHelpTopicsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Title', headerName: 'Title'},
      
        ]);
      }
    
  const fetchHelpTopics=()=>{
    dispatch(helpTopics.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`,entity:'helpTopics',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add Help Topics',
      callback: () => handleAdd(),
    }
  ];
useEffect(() => {
    createColumnDefs()
    fetchHelpTopics()
}, [pageData])
const handleDelete=(data: any)=>{
dispatch(helpTopics.delete({
  url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/delete`,
  entity: 'helpTopics',
  jsonData: {
    Records: [
      {
     
            Id: data?.Id
        }
      
    ]
  }
})).then(() => {
  dispatch(helpTopics.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`,entity:'helpTopics',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
});
}
return (
<>
{helpTopicsItems?.isLoading ?  <PageLoader />: 
<Table columnData={columnDefs} rowData={helpTopicsItems?.result?.items} setPageData={setPageData}
paginationData={helpTopicsItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="Help Topics"/>
 
}
</> 
);
};

export default ManagementHelpTopics;


